<div class="wrapper">
    <div class="text">
        This jurisdiction is not supported by the application. Please contact your administrator.
    </div>
</div>
